export default __webpack_public_path__ + "static/plastika-84a85d8d3a45326cc74745463145236e.jpg";